import { Text } from '@/components/ui/text'
import type { Tables } from '@hvf/contracts'

export default function (props: { setup?: Tables<'setup'>, textStyle?: string, fontSize?: string }) {
  return (
    <Text
      fontSize={props.fontSize || '15px'}
      fontWeight='700'
      color='editorialInk'
    >
      {props.setup?.duration === 'intraday' ? '<Daily' : 'Daily+'}
    </Text>
  )
}
